<template>
  <div>
      <page-table />
  </div>
</template>
<script>
import PageTable from "./components/table"
export default {
  name: "report-reportSample",
  components: { PageTable },
}
</script>
